import React from "react";
import { PRIMARY_LOCALE } from "routes/healthForms/types/common";
import { CataloguePath } from "routes/createContent/paths";
import { useGetTemplates } from "routes/createContent/api/useGetTemplates";
import { useDeleteTemplate } from "routes/createContent/api/useDeleteTemplate";
import { CatalogueList, catalogueQuery, useCatalogueListControls } from "routes/createContent/components/CatalogueList";
import { GroupIcon } from "shared/GroupIcon";
import { useGetTemplateGroups } from "routes/createContent/api/useGetTemplateGroups";

export const Templates: React.VFC = () => {
  const controls = useCatalogueListControls({ inUrl: true, filterKeys: ["groups"] });
  const groups = useGetTemplateGroups();
  const query = useGetTemplates({ ...catalogueQuery(controls), groups: controls.multi("groups") });

  return (
    <CatalogueList
      kind="template"
      title="Templates"
      noun="template"
      newPath={CataloguePath.Templates_New}
      editPath={id => `${CataloguePath.Templates}/${id}`}
      controls={controls}
      query={query}
      deletion={useDeleteTemplate()}
      localized={false}
      toItem={template => ({
        id: template.id,
        name: template.key,
        title: String(template.name[PRIMARY_LOCALE.code] || template.id),
        image: null,
        icon: <GroupIcon group={template.group} />,
        updated_at: template.updated_at,
        deleted_at: template.deleted_at,
        rollout: template.rollout,
      })}
      extraColumns={[{ key: "group", label: "Group", width: 150, value: template => template.group }]}
      extraFilters={[
        {
          label: "Group",
          options: groups.data ?? [],
          value: controls.multi("groups"),
          onChange: controls.setMulti("groups"),
        },
      ]}
    />
  );
};
